import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Container,
  Image,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { withTranslation } from "react-i18next";
import { RiWhatsappFill } from "react-icons/ri";

const RegisterComp = ({ t }) => {
  return (
    <Container maxW={"container.xl"} my={10} id="callCenter">
      <Text
        textAlign="center"
        fontWeight="500"
        fontSize={{ base: "20px", md: "25px" }}
        mb={8}
      >
        {t("components.freq.title")}{" "}
        <Image src={require("../../../assets/line.jpg")} m="auto" mt={3} />
      </Text>

      <Accordion
        defaultIndex={[0]}
        allowMultiple
        bg="#e4e8eb80"
        borderRadius="10px"
        p={2}
      >
        <AccordionItem border={0} my={5}>
          <h2>
            <AccordionButton
              _active={{ outline: "none" }}
              _focus={{ outline: "none" }}
            >
              <AccordionIcon />

              <Box
                as="span"
                flex="1"
                textAlign="right"
                fontWeight="500"
                fontSize="24px"
              >
                {t("components.freq.question")}{" "}
              </Box>
            </AccordionButton>
          </h2>
          <AccordionPanel pb={4} dir="rtl" display="flex" gap={2}>
            {t("components.freq.answer")}{" "}
            <a
              href="https://wa.me/+201025830160"
              target="_blank"
              style={{
                textDecoration: "underline",
                display: "flex",
                alignItems: "center",
                gap: "2px",
              }}
            >
              {" "}
              <span>WhatsApp </span>
              <RiWhatsappFill color="green" fontSize="20px" />
            </a>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Container>
  );
};

export default withTranslation()(RegisterComp);
